import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import Api from '../../Classes/API/UsersApi';
import CreateAccountingEntryModel  from '../../Classes/Models/Requests/Accounting/CreateAccountingEntryReq';
import SearchUserModel from '../../Classes/Models/Requests/Users/SearchUser';
import SearchAccountingSessions from '../../Classes/Models/Requests/Accounting/SearchAccountingSession';
import SearchTherapistTypes from '../../Classes/Models/Requests/Administration/Therapists/SearchTherapistTypes';
import SearchAccountingTherapistHourId from '../../Classes/Models/Requests/Accounting/SearchAccountingTherapistHourId';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from "examples/Navbars/DashboardNavbar"; 
import MDBox from "components/MDBox"; 

const CreateAccountingEntry = () => {

  let CreateModel = new CreateAccountingEntryModel();
  let Users = [];
  let AccountingSessions = [];
  let TherapistTypes = [];
  let accountingTherapistHourIds = [];

  const [title, SetTitle] = useState("");
  const [amount, SetAmount] = useState(0);
  const [description, SetDescription] = useState("");
  const [category, SetCategory] = useState("");
  const [entryType, SetEntryType] = useState("");
  const [isProfit, SetisProfit] = useState(false);
  const [patientId, SetpatientId] = useState(0);
  const [accountingSessionId, SetaccountingSessionId] = useState(0);
  const [therapistId, SettherapistId] = useState(0);
  const [accountingTherapistHourId, SetaccountingTherapistHourId] = useState(0);

  function SearchAccountingSession(req) {
    Api.SearchAccountingSession(req).then(res => {
      AccountingSessions = res.data;
      console.log(AccountingSessions);
    })
  }

  function SearchUsers(req) {
    Api.SearchUsers(req).then(res => {
      Users = res.data;
      console.log(Users);
    })
  }

  function SearchTherapistTypesFun(req) {
    Api.SearchTherapistTypes(req).then(res => {
      TherapistTypes.push(...res.data.list);
      console.log(TherapistTypes);
    })
  }

  function SearchaccountingTherapistHourIdFun(req) {
    Api.accountingTherapistHourId(req).then(res => {
      accountingTherapistHourIds = res.data;
      console.log(accountingTherapistHourIds);
    })
  }

  useEffect(() => {
    let users = SearchUserModel;
    users.userType = "Patient";
    SearchUsers(users);

    let accountingSessions = SearchAccountingSessions;
    SearchAccountingSession(accountingSessions);

    let therapistTypes = SearchTherapistTypes;
    SearchTherapistTypesFun(therapistTypes);
  }, ['default']);


  useEffect(() => {
    let accountingTherapistHourIds = SearchAccountingTherapistHourId;
    accountingTherapistHourIds.therapistId = therapistId;
    SearchaccountingTherapistHourIdFun(accountingTherapistHourIds);
  }, [therapistId]);


  function submitForm() {
    let id = localStorage.getItem('userId');
    let model = CreateModel(id, title, amount, description, category, entryType, isProfit, patientId, accountingSessionId, therapistId, accountingTherapistHourId, null, null, timeStamp);

    Api.CreateAccountingEntry(model).then(res => {
      Swal.fire({
        title: 'Success',
        text: 'Accounting Entry Created Successfully',
        icon: 'success',
        confirmButtonText: 'Ok'
      })
    }).catch(err => {
      Swal.fire({
        title: 'Error',
        text: 'Error Creating Accounting Entry',
        icon: 'error',
        confirmButtonText: 'Ok'
      })
    })
  }


  return (
    <div>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mt={6} mb={3}>
          <div className="card-body">

            <div className="row">
              <div className="container">

                {/* title */}
                <div className="input-group input-group-md">
                  <input type="text" className="form-control" placeholder="title" aria-describedby="sizing-addon1" onChange={(e) => SetTitle(e.target.value)} />
                </div>

                {/* amount */}
                <div className="input-group input-group-md">
                  <input type="text" className="form-control" placeholder="amount" aria-describedby="sizing-addon1" onChange={(e) => SetAmount(e.target.value)} />
                </div>

                {/* description */}
                <div className="input-group input-group-md">
                  <input type="text" className="form-control" placeholder="description" aria-describedby="sizing-addon1" onChange={(e) => SetDescription(e.target.value)} />
                </div>

                {/* category */}
                <div className="input-group input-group-md">
                  <input type="text" className="form-control" placeholder="category" aria-describedby="sizing-addon1" onChange={(e) => SetCategory(e.target.value)} />
                </div>

                {/* entryType */}
                <div className="input-group input-group-md">
                  <input type="text" className="form-control" placeholder="entryType" aria-describedby="sizing-addon1" onChange={(e) => SetEntryType(e.target.value)} />
                </div>

                {/* isProfit */}
                <div className="input-group-text">
                  <input type="checkbox" aria-label="Checkbox for following text input" onChange={(e) => SetisProfit(e.target.value)} />
                </div>

                {/* patientId */}
                <select className="custom-select" onChange={(e) => SetpatientId(e.target.value)}>
                  {Users.map(user => (
                    <option value={user.id}>{user.firstName} {user.lastName}</option>
                  ))}
                </select>

                {/* accountingSessionId */}
                <select className="custom-select" onChange={(e) => SetaccountingSessionId(e.target.value)} >
                  {AccountingSessions.map(accountingSession => (
                    <option value={accountingSession.id}>{accountingSession.title}</option>
                  ))}
                </select>

                {/* therapistId */}
                <select className="custom-select" onChange={(e) => SettherapistId(e.target.value)}>
                  {TherapistTypes.map(therapistType => (
                    <option value={therapistType.id}>{therapistType.typeName}</option>
                  ))}
                </select>

                {/* accountingTherapistHourId */}
                <select className="custom-select" onChange={(e) => SetaccountingTherapistHourId(e.target.value)}>
                  {accountingTherapistHourIds.map(accountingTherapistHourId => (
                    <option value={accountingTherapistHourId.id}>{accountingTherapistHourId.id}</option>
                  ))}
                </select>



                <button type="button" className='btn btn-primary mt-2 float-right' onClick={submitForm}>Create</button>

              </div>

            </div>



          </div>
        </MDBox>
      </DashboardLayout>
    </div>
  );

}
export default CreateAccountingEntry;